import clsx from 'clsx';
import React from 'react';
import { toggleSwitch } from '../../reducers/switch';
import ToggleIcon from '../../assets/icons/sidebar-toggle-icon.svg?react';
import EmailIcon from '../../assets/icons/mail-icon.svg?react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router';
import Button from '../../components/Button';

interface ContactSupportProps {
  otherClasses?: string;
}

const ContactSupport: React.FC<ContactSupportProps> = ({ otherClasses }) => {
  const contactSupportClasses = clsx(
    otherClasses,
    'px-15 md:px-6 lg:pl-8 pt-14 lg:pr-14 pb-9 w-full',
  );
  const dispatch = useDispatch();

  return (
    <div className={contactSupportClasses} data-testid="contact-support">
      <div className="border-b-neutral-tones-text/35 border-b pb-6 lg:border-b-0 lg:pb-0">
        <div className="flex items-start gap-2.5">
          <button
            className="bg-translucent-background/80 border-neutral-tones-text/30 rounded-5 cursor-pointer border p-0.5 lg:hidden"
            onClick={() => dispatch(toggleSwitch())}
          >
            <ToggleIcon />
          </button>
          <div>
            <h1 className="h3 text-brand-byzantine">Contact Support</h1>
            <p className="font-inter-variable text-neutral-tones-text/80 -tracking-button mt-15 hidden text-xl leading-6 font-medium lg:block">
              Encountered an issue?{' '}
              <Link to="/faqs" className="text-brand-byzantine font-bold">
                Read FAQs
              </Link>{' '}
              or{' '}
              <Link
                to="/user-guides"
                className="text-brand-byzantine font-bold"
              >
                Read User Guide
              </Link>
            </p>
          </div>
        </div>
        <p className="font-inter-variable text-neutral-tones-text/80 -tracking-text-area mt-15 text-lg leading-5 font-medium lg:hidden">
          Encountered an issue?{' '}
          <span className="mt-1 block md:inline">
            <Link to="/faqs" className="text-brand-byzantine font-bold">
              Read FAQs
            </Link>{' '}
            or{' '}
            <Link to="/user-guides" className="text-brand-byzantine font-bold">
              Read User Guide
            </Link>
          </span>
        </p>
      </div>
      <div className="mt-6 grid max-w-[800px] grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-12 lg:grid-cols-1 xl:grid-cols-2">
        <div className="bg-card-backgrounds/5 rounded-10 px-15 py-5 lg:p-5">
          <div className="mb-15 flex items-center gap-1 lg:mb-5 lg:gap-5">
            <EmailIcon className="h-9 w-9 lg:h-75 lg:w-75" />
            <div>
              <h6 className="font-inter-variable text-neutral-tones-text mb-2.5 text-base leading-5 font-bold lg:text-xl lg:leading-6">
                Email Support
              </h6>
              <p className="text-neutral-tones-text font-inter-variable text-sm leading-4 font-normal lg:text-lg lg:leading-5">
                support@ehsnavigator.com
              </p>
            </div>
          </div>
          <Button
            size="smaller"
            otherClasses="w-full"
            href="mailto:support@ehsnavigator.com"
          >
            Send Email
          </Button>
        </div>
      </div>
      <p className="text-neutral-tones-text font-inter-variable mt-6 text-base leading-5 font-medium lg:mt-12 lg:text-xl lg:leading-6">
        Having trouble? Let us know by submitting your feedback through the bot
        widget below!
      </p>
    </div>
  );
};

export default ContactSupport;
